import * as React from 'react'
import { App } from '..'

const MainPage: React.FC = () => <App />

export default MainPage
